import { exampleSetup } from 'prosemirror-example-setup'
import {
  ellipsis,
  emDash,
  inputRules,
  smartQuotes,
  textblockTypeInputRule,
  wrappingInputRule,
} from 'prosemirror-inputrules'

// exampleSetup's rules minus "1. " → ordered list: German dates ("24. Oktober") must stay text
const buildInputRules = ({ nodes }) => inputRules({
  rules: [
    ...smartQuotes,
    ellipsis,
    emDash,
    nodes.blockquote && wrappingInputRule(/^\s*>\s$/, nodes.blockquote),
    nodes.bullet_list && wrappingInputRule(/^\s*([-+*])\s$/, nodes.bullet_list),
    nodes.code_block && textblockTypeInputRule(/^```$/, nodes.code_block),
    nodes.heading && textblockTypeInputRule(
      /^(#{1,6})\s$/,
      nodes.heading,
      match => ({ level: match[1].length })
    ),
  ].filter(Boolean),
})

export const editorSetup = options => [
  buildInputRules(options.schema),
  ...exampleSetup(options).filter(plugin => !plugin.spec.isInputRules),
]
